import {
  CampaignMessage,
  FundraisingAmbassadors,
  FundraisingAssets,
  FundraisingInfo,
  FundraisingMatchingInfo,
  FundraisingNotifications,
  FundraisingProductsInfo,
  FundraisingState,
  MainAssets,
  SecondaryAssets,
} from 'src/models/FundraisingModel';
import { FundraisingLanguages } from 'src/constants/FundraisingLanguages';
import moment from 'moment/moment';

export enum FundraisingTypes {
  matching = 'matching',
  standard = 'standard',
  event = 'event',
  ticketing = 'ticketing',
}

export enum FundraisingSections {
  info = 'info',
  matching = 'matching',
  products = 'products',
  notifications = 'notifications',
  assets = 'assets',
  ambassadors = 'ambassadors',
}

export const defaultFundraisingInfo: FundraisingInfo = {
  id: 0,
  state: FundraisingState.draft,
  type: FundraisingTypes.standard,
  name: '',
  slug: '',
  active: false,
  default_language: FundraisingLanguages.en, // example default
  start_date: moment().add(1, 'day').startOf('day'),
  end_date: moment(),
  has_end: false,
  show_countdown: false,
  countdown_end_date: moment(),
  ask_for_fee: false,
  admin_fee: '',
  show_suggested: false,
  max_amount: 0,
  program_id: 0,
  department_id: 0,
  account_id: 0,
  bank_account_id: 0,
  payment_gateway_id: 0,
  allow_installment: false,
  max_installments: 0,
  group_ids: [],
};

export const defaultFundraisingMatching: FundraisingMatchingInfo = {
  active_matching: false,
  end_amount_multiplier: '',
  bonus_round_active: false,
  bonus_round_goal: '',
  goal: '',
  matching_multiplier: '',
  show_goal: false,
  show_raised_amount: false,
  start_amount_multiplier: '',
};

export const defaultFundraisingAmbassadors: FundraisingAmbassadors = {
  message_sms: '',
  message_email: '',
  show_ambassador_section: false,
  show_ambassador_goal: false,
  show_ambassador_real_amount: false,
  show_donors_section: false,
  show_donor_real_amount: false,
  show_donor_amount: false,
  show_donors_comments: false,
};

export const defaultFundraisingProducts: FundraisingProductsInfo = {
  all_products_visible: false,
  show_in_dropdown: false,
  show_suggested: false,
  ask_for_fee: false,
  fixed_price_as_checkbox: false,
  fixed_price_allow_quantity: false,
  product_fee_id: 0,
  product_suggested_id: 0,
  products: [],
};

export const defaultFundraisingNotifications: FundraisingNotifications = {
  contacts: [],
  thanks_email_title: '',
  thanks_email_body: '',
  thanks_sms_text: '',
  send_thanks_email: false,
  send_thanks_sms: false,
  send_email_notifications: false,
  send_sms_notifications: false,
  fb_title: '',
  fb_description: '',
};

export const defaultFundraisingAssets: FundraisingAssets = {
  theme_color: '',
  show_main_slider: false,
  main_slider: {} as MainAssets,
  main_slider_delay: '10',
  show_secondary_slider: false,
  secondary_slider: {} as SecondaryAssets,
  secondary_slider_delay: '10',
  show_matcher_slider: false,
  matcher_slider: [] as string[],
  matcher_slider_delay: '10',
  show_sponsor_slider: false,
  sponsor_slider: [] as string[],
  sponsor_slider_delay: '10',
  show_products_slider: false,
  campaign_message: {} as CampaignMessage,
  campaign_logo: {} as CampaignMessage,
  sections: [] as string[],
};

const FundraisingInfoBool = [
  'active', 'has_end', 'show_countdown', 'ask_for_fee', 'show_goal', 'show_suggested', 'allow_installment',
];

const FundraisingMatchingBool = [
  'allow_installment', 'show_goal', 'bonus_round_active', 'active_matching',
];

const FundraisingProductsBool = [
  'all_products_visible', 'show_in_dropdown', 'fixed_price_as_checkbox', 'fixed_price_allow_quantity',
];

const FundraisingAmbassadorsBool = [
  'show_ambassador_section', 'show_ambassador_goal', 'show_ambassador_real_amount',
  'show_donors_section', 'show_donor_real_amount', 'show_donor_amount', 'show_donors_comments',
];

const FundraisingNotificationsBool = [
  'send_thanks_email', 'send_thanks_sms', 'send_email_notifications', 'send_sms_notifications',
];

const FundraisingAssetsBool = [
  'show_main_slider', 'show_main_video', 'show_secondary_slider', 'show_secondary_video',
];

export const fundraisingBooleans: Record<FundraisingSections, readonly string[]> = {
  info: FundraisingInfoBool,
  matching: FundraisingMatchingBool,
  products: FundraisingProductsBool,
  ambassadors: FundraisingAmbassadorsBool,
  notifications: FundraisingNotificationsBool,
  assets: FundraisingAssetsBool,
};
